import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

/* The table renders this cell inside a paragraph, so every element here stays inline-level */
export const ReviewEntriesSupplierCellWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: ${Spacing.S4};
  width: 100%;
`

export const ReviewEntriesSupplierName = styled.span`
  flex: 1;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const ReviewEntriesSupplierTagWrapper = styled.span`
  display: flex;
  flex-shrink: 0;
`
